// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectAccountOperationMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_ACCOUNOPERATION_MESSAGE);
    }
}
